import React from 'react';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from 'recharts';
import { BsBarChartLineFill } from 'react-icons/bs';
import { CHART_COLORS } from '../../../../core/constants/financial';

const compact = (v) => {
  const n = Number(v) || 0;
  if (Math.abs(n) >= 1000) return `R$ ${(n / 1000).toFixed(0)}k`;
  return `R$ ${n}`;
};

// Card com o gráfico de linha: Faturamento x Despesas x Resultado nos últimos meses.
const MonthlyTrendChart = ({ data, colors, brl, loading }) => (
  <section className="dg-card dg-chart-card">
    <div className="dg-section-title">
      <span className="dg-title-icon"><BsBarChartLineFill /></span>
      <span>Faturamento × Despesas × Resultado</span>
    </div>
    <div className="dg-chart-content">
      <ResponsiveContainer width="100%" height={210}>
        <LineChart data={data} margin={{ top: 8, right: 12, bottom: 0, left: 0 }}>
          <CartesianGrid stroke={CHART_COLORS.grid} vertical={false} />
          <XAxis
            dataKey="mes"
            tick={{ fill: CHART_COLORS.tick, fontSize: 11 }}
            axisLine={{ stroke: CHART_COLORS.axis }}
            tickLine={false}
          />
          <YAxis
            tick={{ fill: CHART_COLORS.tick, fontSize: 11 }}
            axisLine={false}
            tickLine={false}
            width={44}
            tickFormatter={compact}
          />
          <Tooltip
            formatter={(v) => brl(v)}
            contentStyle={{ background: CHART_COLORS.tooltipBg, border: '1px solid #383838', borderRadius: 6, fontSize: 12 }}
            itemStyle={{ color: '#fff' }}
            labelStyle={{ color: CHART_COLORS.tick, marginBottom: 2 }}
          />
          <Legend wrapperStyle={{ fontSize: 11, paddingTop: 6 }} iconType="plainline" />
          <Line type="monotone" dataKey="faturamento" name="Faturamento" stroke={colors.blue} strokeWidth={2} dot={{ r: 3, fill: colors.blue, strokeWidth: 0 }} isAnimationActive={!loading} />
          <Line type="monotone" dataKey="despesas" name="Despesas" stroke={colors.red} strokeWidth={2} dot={{ r: 3, fill: colors.red, strokeWidth: 0 }} isAnimationActive={!loading} />
          <Line type="monotone" dataKey="resultado" name="Resultado" stroke={colors.green} strokeWidth={2} dot={{ r: 3, fill: colors.green, strokeWidth: 0 }} isAnimationActive={!loading} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  </section>
);

export default MonthlyTrendChart;
